import {Component, Input} from '@angular/core';

import {SubtitlesService, ViewsService, ZonesService} from "../../core";
import {DHWTileType250} from "../../models";

@Component({
    selector: 'dhw-on-off',
    templateUrl: './dhw-on-off.component.html',
    styleUrls: ['./dhw-on-off.component.scss']
})
export class DHWOnOffComponent {
    @Input() tile: DHWTileType250;

    constructor(
        public views: ViewsService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }
}
